import { Button } from "devextreme-react";
import React from "react";
import { useAuth } from "../../contexts/auth";
import CustomButton from "../customButton/CustomButton";
import { HeaderText } from "../typographyText/TypographyText";
import "./CancelSaveHeader.scss";

export default function CancelSaveHeader({
  titleName,
  handleDetCancel,
  handleDetSave,
}) {
  const { user } = useAuth();
  return (
    <div className="pageHead">
      <div className="leftSection">
        <HeaderText text={titleName} />
      </div>
      <div className="btnSection">
          <>
            <div className="cancelSection">
              <Button text="Cancel" height={"40px"} onClick={handleDetCancel} />
            </div>

            <div className="create-button">
              <CustomButton text={"Save Details"} onClick={handleDetSave} />
            </div>
          </>
      </div>
    </div>
  );
}
